import { BottomSheetModal, useModal } from "@becon-team/becon-fe-lib/my-modal";
import { selectLanguage } from "@becon-team/becon-fe-lib/utils";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { languageLabels } from "libs/i18n";
import { modalIds } from "libs/my-modal";

export const LanguageSelectModal = () => {
  const modalId = modalIds["language-select"];
  const { t, i18n } = useTranslation();

  const { modal, closeModal } = useModal(modalId);
  const { isOpened } = modal;

  return (
    <BottomSheetModal
      closeModal={closeModal}
      titleSection={t("언어 변경")}
      isOpened={isOpened}
      isCloseModalOutsideClick={true}
    >
      <div className="border-t border-base-100 pb-sp-32">
        {languageLabels.map((language, idx) => (
          <div
            key={idx}
            className="my-btn-etc border-b border-base-100 px-inner-padding py-sp-16 text-md"
            onClick={() => {
              selectLanguage(i18n, language[0], languageLabels);
              closeModal();
            }}
          >
            {language[1]}
          </div>
        ))}
      </div>
    </BottomSheetModal>
  );
};

export const useLanguageSelectModal = () => {
  const { modal, openModal, closeModal } = useModal(modalIds["language-select"]);

  const openModalCallback = useCallback(() => {
    openModal();
  }, [openModal]);

  return {
    openModal: openModalCallback,
    closeModal,
    isOpened: modal.isOpened,
  };
};
